import { AppState } from 'store/types';
import { initialState } from './constants';

export const getProfilesState = (state: AppState) => state.profiles || initialState;